/**
 * #subreddits_svc.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Empty } from "../../../../google/protobuf/empty.js";
import { StringValue } from "../../../../google/protobuf/wrappers.js";
import { JsonStatus, Listing } from "../common/common_msg.js";
import { AboutWhereRequest, AddSubredditRuleRequest, BasicSearchRequest, BasicSubredditRequest, BasicWhereRequest, DeleteSrImgRequest, GetHighlightedPostsRequest, GetHighlightedPostsResponse, RemoveSubredditRuleRequest, ReorderHighlightedPostsRequest, ReorderHighlightedPostsResponse, ReorderSubredditRulesRequest, SearchRedditNamesResponse, SearchSubredditsResponse, SiteAdminRequest, StickyRequest, StickyResponse, SubmitTextResponse, SubredditAboutEditRequest, SubredditAboutEditResponse, SubredditAboutResponse, SubredditAboutRulesResponse, SubredditAboutTrafficResponse, SubredditAddRemovalReasonRequest, SubredditAddRemovalReasonResponse, SubredditAutocompleteRequest, SubredditAutocompleteResponse, SubredditDeleteRemovalReasonRequest, SubredditDeleteRemovalReasonResponse, SubredditGetRemovalReasonsRequest, SubredditGetRemovalReasonsResponse, SubredditPostRequirementsResponse, SubredditsSearchRequest, SubredditsSearchResponse, SubredditStylesheetRequest, SubredditUpdateRemovalReasonRequest, SubredditUpdateRemovalReasonResponse, SubscribeRequest, UpdateSubredditRuleRequest, UploadSrImgRequest, UploadSrImgResponse, UserSearchResponse, UsersSearchRequest, } from "./subreddits_msg.js";
export const SubredditsServiceName = "devvit.plugin.redditapi.subreddits.Subreddits";
export class SubredditsClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || SubredditsServiceName;
        this.rpc = rpc;
        this.AboutWhere = this.AboutWhere.bind(this);
        this.DeleteSrBanner = this.DeleteSrBanner.bind(this);
        this.DeleteSrHeader = this.DeleteSrHeader.bind(this);
        this.DeleteSrIcon = this.DeleteSrIcon.bind(this);
        this.DeleteSrImg = this.DeleteSrImg.bind(this);
        this.SearchRedditNames = this.SearchRedditNames.bind(this);
        this.SearchSubreddits = this.SearchSubreddits.bind(this);
        this.SiteAdmin = this.SiteAdmin.bind(this);
        this.SubmitText = this.SubmitText.bind(this);
        this.SubredditAutocomplete = this.SubredditAutocomplete.bind(this);
        this.SubredditStylesheet = this.SubredditStylesheet.bind(this);
        this.Subscribe = this.Subscribe.bind(this);
        this.UploadSrImg = this.UploadSrImg.bind(this);
        this.SubredditPostRequirements = this.SubredditPostRequirements.bind(this);
        this.SubredditAbout = this.SubredditAbout.bind(this);
        this.SubredditAboutEdit = this.SubredditAboutEdit.bind(this);
        this.SubredditAboutRules = this.SubredditAboutRules.bind(this);
        this.AddSubredditRule = this.AddSubredditRule.bind(this);
        this.UpdateSubredditRule = this.UpdateSubredditRule.bind(this);
        this.RemoveSubredditRule = this.RemoveSubredditRule.bind(this);
        this.ReorderSubredditRules = this.ReorderSubredditRules.bind(this);
        this.SubredditAboutTraffic = this.SubredditAboutTraffic.bind(this);
        this.Sidebar = this.Sidebar.bind(this);
        this.Sticky = this.Sticky.bind(this);
        this.SubredditsMineWhere = this.SubredditsMineWhere.bind(this);
        this.SubredditsSearch = this.SubredditsSearch.bind(this);
        this.SubredditsWhere = this.SubredditsWhere.bind(this);
        this.UsersSearch = this.UsersSearch.bind(this);
        this.UsersWhere = this.UsersWhere.bind(this);
        this.SubredditAddRemovalReason = this.SubredditAddRemovalReason.bind(this);
        this.SubredditGetRemovalReasons = this.SubredditGetRemovalReasons.bind(this);
        this.SubredditUpdateRemovalReason = this.SubredditUpdateRemovalReason.bind(this);
        this.SubredditDeleteRemovalReason = this.SubredditDeleteRemovalReason.bind(this);
        this.GetHighlightedPosts = this.GetHighlightedPosts.bind(this);
        this.ReorderHighlightedPosts = this.ReorderHighlightedPosts.bind(this);
    }
    AboutWhere(request, metadata) {
        const data = AboutWhereRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AboutWhere", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
    DeleteSrBanner(request, metadata) {
        const data = BasicSubredditRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "DeleteSrBanner", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    DeleteSrHeader(request, metadata) {
        const data = BasicSubredditRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "DeleteSrHeader", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    DeleteSrIcon(request, metadata) {
        const data = BasicSubredditRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "DeleteSrIcon", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    DeleteSrImg(request, metadata) {
        const data = DeleteSrImgRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "DeleteSrImg", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    SearchRedditNames(request, metadata) {
        const data = BasicSearchRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SearchRedditNames", data, metadata);
        return promise.then((data) => SearchRedditNamesResponse.decode(_m0.Reader.create(data)));
    }
    SearchSubreddits(request, metadata) {
        const data = BasicSearchRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SearchSubreddits", data, metadata);
        return promise.then((data) => SearchSubredditsResponse.decode(_m0.Reader.create(data)));
    }
    SiteAdmin(request, metadata) {
        const data = SiteAdminRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SiteAdmin", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    SubmitText(request, metadata) {
        const data = BasicSubredditRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubmitText", data, metadata);
        return promise.then((data) => SubmitTextResponse.decode(_m0.Reader.create(data)));
    }
    SubredditAutocomplete(request, metadata) {
        const data = SubredditAutocompleteRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditAutocomplete", data, metadata);
        return promise.then((data) => SubredditAutocompleteResponse.decode(_m0.Reader.create(data)));
    }
    SubredditStylesheet(request, metadata) {
        const data = SubredditStylesheetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditStylesheet", data, metadata);
        return promise.then((data) => JsonStatus.decode(_m0.Reader.create(data)));
    }
    Subscribe(request, metadata) {
        const data = SubscribeRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Subscribe", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    UploadSrImg(request, metadata) {
        const data = UploadSrImgRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UploadSrImg", data, metadata);
        return promise.then((data) => UploadSrImgResponse.decode(_m0.Reader.create(data)));
    }
    SubredditPostRequirements(request, metadata) {
        const data = BasicSubredditRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditPostRequirements", data, metadata);
        return promise.then((data) => SubredditPostRequirementsResponse.decode(_m0.Reader.create(data)));
    }
    SubredditAbout(request, metadata) {
        const data = BasicSubredditRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditAbout", data, metadata);
        return promise.then((data) => SubredditAboutResponse.decode(_m0.Reader.create(data)));
    }
    SubredditAboutEdit(request, metadata) {
        const data = SubredditAboutEditRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditAboutEdit", data, metadata);
        return promise.then((data) => SubredditAboutEditResponse.decode(_m0.Reader.create(data)));
    }
    SubredditAboutRules(request, metadata) {
        const data = BasicSubredditRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditAboutRules", data, metadata);
        return promise.then((data) => SubredditAboutRulesResponse.decode(_m0.Reader.create(data)));
    }
    AddSubredditRule(request, metadata) {
        const data = AddSubredditRuleRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AddSubredditRule", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    UpdateSubredditRule(request, metadata) {
        const data = UpdateSubredditRuleRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdateSubredditRule", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    RemoveSubredditRule(request, metadata) {
        const data = RemoveSubredditRuleRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "RemoveSubredditRule", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    ReorderSubredditRules(request, metadata) {
        const data = ReorderSubredditRulesRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ReorderSubredditRules", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    SubredditAboutTraffic(request, metadata) {
        const data = BasicSubredditRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditAboutTraffic", data, metadata);
        return promise.then((data) => SubredditAboutTrafficResponse.decode(_m0.Reader.create(data)));
    }
    Sidebar(request, metadata) {
        const data = BasicSubredditRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Sidebar", data, metadata);
        return promise.then((data) => StringValue.decode(_m0.Reader.create(data)));
    }
    Sticky(request, metadata) {
        const data = StickyRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Sticky", data, metadata);
        return promise.then((data) => StickyResponse.decode(_m0.Reader.create(data)));
    }
    SubredditsMineWhere(request, metadata) {
        const data = BasicWhereRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditsMineWhere", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
    SubredditsSearch(request, metadata) {
        const data = SubredditsSearchRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditsSearch", data, metadata);
        return promise.then((data) => SubredditsSearchResponse.decode(_m0.Reader.create(data)));
    }
    SubredditsWhere(request, metadata) {
        const data = BasicWhereRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditsWhere", data, metadata);
        return promise.then((data) => SubredditsSearchResponse.decode(_m0.Reader.create(data)));
    }
    UsersSearch(request, metadata) {
        const data = UsersSearchRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UsersSearch", data, metadata);
        return promise.then((data) => UserSearchResponse.decode(_m0.Reader.create(data)));
    }
    UsersWhere(request, metadata) {
        const data = BasicWhereRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UsersWhere", data, metadata);
        return promise.then((data) => SubredditsSearchResponse.decode(_m0.Reader.create(data)));
    }
    SubredditAddRemovalReason(request, metadata) {
        const data = SubredditAddRemovalReasonRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditAddRemovalReason", data, metadata);
        return promise.then((data) => SubredditAddRemovalReasonResponse.decode(_m0.Reader.create(data)));
    }
    SubredditGetRemovalReasons(request, metadata) {
        const data = SubredditGetRemovalReasonsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditGetRemovalReasons", data, metadata);
        return promise.then((data) => SubredditGetRemovalReasonsResponse.decode(_m0.Reader.create(data)));
    }
    SubredditUpdateRemovalReason(request, metadata) {
        const data = SubredditUpdateRemovalReasonRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditUpdateRemovalReason", data, metadata);
        return promise.then((data) => SubredditUpdateRemovalReasonResponse.decode(_m0.Reader.create(data)));
    }
    SubredditDeleteRemovalReason(request, metadata) {
        const data = SubredditDeleteRemovalReasonRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SubredditDeleteRemovalReason", data, metadata);
        return promise.then((data) => SubredditDeleteRemovalReasonResponse.decode(_m0.Reader.create(data)));
    }
    GetHighlightedPosts(request, metadata) {
        const data = GetHighlightedPostsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetHighlightedPosts", data, metadata);
        return promise.then((data) => GetHighlightedPostsResponse.decode(_m0.Reader.create(data)));
    }
    ReorderHighlightedPosts(request, metadata) {
        const data = ReorderHighlightedPostsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ReorderHighlightedPosts", data, metadata);
        return promise.then((data) => ReorderHighlightedPostsResponse.decode(_m0.Reader.create(data)));
    }
}
export const SubredditsDefinition = {
    name: "Subreddits",
    fullName: "devvit.plugin.redditapi.subreddits.Subreddits",
    methods: {
        /** https://www.reddit.com/dev/api#GET_about_\{where\} */
        aboutWhere: {
            name: "AboutWhere",
            requestType: AboutWhereRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            112,
                            18,
                            110,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            98,
                            111,
                            117,
                            116,
                            47,
                            123,
                            119,
                            104,
                            101,
                            114,
                            101,
                            125,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                            38,
                            117,
                            115,
                            101,
                            114,
                            61,
                            123,
                            117,
                            115,
                            101,
                            114,
                            125,
                        ]),
                        new Uint8Array([2, 64, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                        new Uint8Array([2, 88, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_delete_sr_banner */
        deleteSrBanner: {
            name: "DeleteSrBanner",
            requestType: BasicSubredditRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            37,
                            18,
                            35,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            100,
                            101,
                            108,
                            101,
                            116,
                            101,
                            95,
                            115,
                            114,
                            95,
                            98,
                            97,
                            110,
                            110,
                            101,
                            114,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_delete_sr_header */
        deleteSrHeader: {
            name: "DeleteSrHeader",
            requestType: BasicSubredditRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            37,
                            18,
                            35,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            100,
                            101,
                            108,
                            101,
                            116,
                            101,
                            95,
                            115,
                            114,
                            95,
                            104,
                            101,
                            97,
                            100,
                            101,
                            114,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_delete_sr_icon */
        deleteSrIcon: {
            name: "DeleteSrIcon",
            requestType: BasicSubredditRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            35,
                            18,
                            33,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            100,
                            101,
                            108,
                            101,
                            116,
                            101,
                            95,
                            115,
                            114,
                            95,
                            105,
                            99,
                            111,
                            110,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_delete_sr_img */
        deleteSrImg: {
            name: "DeleteSrImg",
            requestType: DeleteSrImgRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            34,
                            18,
                            32,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            100,
                            101,
                            108,
                            101,
                            116,
                            101,
                            95,
                            115,
                            114,
                            95,
                            105,
                            109,
                            103,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_search_reddit_names */
        searchRedditNames: {
            name: "SearchRedditNames",
            requestType: BasicSearchRequest,
            requestStream: false,
            responseType: SearchRedditNamesResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            26,
                            18,
                            24,
                            47,
                            97,
                            112,
                            105,
                            47,
                            115,
                            101,
                            97,
                            114,
                            99,
                            104,
                            95,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            95,
                            110,
                            97,
                            109,
                            101,
                            115,
                        ]),
                        new Uint8Array([2, 24, 4]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_search_subreddits */
        searchSubreddits: {
            name: "SearchSubreddits",
            requestType: BasicSearchRequest,
            requestStream: false,
            responseType: SearchSubredditsResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            24,
                            18,
                            22,
                            47,
                            97,
                            112,
                            105,
                            47,
                            115,
                            101,
                            97,
                            114,
                            99,
                            104,
                            95,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            115,
                        ]),
                        new Uint8Array([2, 24, 4]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_site_admin */
        siteAdmin: {
            name: "SiteAdmin",
            requestType: SiteAdminRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([17, 18, 15, 47, 97, 112, 105, 47, 115, 105, 116, 101, 95, 97, 100, 109, 105, 110]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([4, 58, 2, 115, 114]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_api_submit_text */
        submitText: {
            name: "SubmitText",
            requestType: BasicSubredditRequest,
            requestStream: false,
            responseType: SubmitTextResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            32,
                            18,
                            30,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            115,
                            117,
                            98,
                            109,
                            105,
                            116,
                            95,
                            116,
                            101,
                            120,
                            116,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * TODO: this seems to return a Listing, not a SubredditAutocompleteResponse.
         * https://www.reddit.com/dev/api#GET_api_subreddit_autocomplete_v2
         */
        subredditAutocomplete: {
            name: "SubredditAutocomplete",
            requestType: SubredditAutocompleteRequest,
            requestStream: false,
            responseType: SubredditAutocompleteResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            201,
                            1,
                            18,
                            198,
                            1,
                            47,
                            97,
                            112,
                            105,
                            47,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            95,
                            97,
                            117,
                            116,
                            111,
                            99,
                            111,
                            109,
                            112,
                            108,
                            101,
                            116,
                            101,
                            95,
                            118,
                            50,
                            63,
                            105,
                            110,
                            99,
                            108,
                            117,
                            100,
                            101,
                            95,
                            111,
                            118,
                            101,
                            114,
                            95,
                            49,
                            56,
                            61,
                            123,
                            105,
                            110,
                            99,
                            108,
                            117,
                            100,
                            101,
                            95,
                            111,
                            118,
                            101,
                            114,
                            95,
                            49,
                            56,
                            125,
                            38,
                            105,
                            110,
                            99,
                            108,
                            117,
                            100,
                            101,
                            95,
                            112,
                            114,
                            111,
                            102,
                            105,
                            108,
                            101,
                            115,
                            61,
                            123,
                            105,
                            110,
                            99,
                            108,
                            117,
                            100,
                            101,
                            95,
                            112,
                            114,
                            111,
                            102,
                            105,
                            108,
                            101,
                            115,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            113,
                            117,
                            101,
                            114,
                            121,
                            61,
                            123,
                            113,
                            117,
                            101,
                            114,
                            121,
                            125,
                            38,
                            115,
                            101,
                            97,
                            114,
                            99,
                            104,
                            95,
                            113,
                            117,
                            101,
                            114,
                            121,
                            95,
                            105,
                            100,
                            61,
                            123,
                            115,
                            101,
                            97,
                            114,
                            99,
                            104,
                            95,
                            113,
                            117,
                            101,
                            114,
                            121,
                            95,
                            105,
                            100,
                            125,
                            38,
                            116,
                            121,
                            112,
                            101,
                            97,
                            104,
                            101,
                            97,
                            100,
                            95,
                            97,
                            99,
                            116,
                            105,
                            118,
                            101,
                            61,
                            123,
                            116,
                            121,
                            112,
                            101,
                            97,
                            104,
                            101,
                            97,
                            100,
                            95,
                            97,
                            99,
                            116,
                            105,
                            118,
                            101,
                            125,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_subreddit_stylesheet */
        subredditStylesheet: {
            name: "SubredditStylesheet",
            requestType: SubredditStylesheetRequest,
            requestStream: false,
            responseType: JsonStatus,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            41,
                            18,
                            39,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            95,
                            115,
                            116,
                            121,
                            108,
                            101,
                            115,
                            104,
                            101,
                            101,
                            116,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_subscribe */
        subscribe: {
            name: "Subscribe",
            requestType: SubscribeRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {},
        },
        /** https://www.reddit.com/dev/api#POST_api_upload_sr_img */
        uploadSrImg: {
            name: "UploadSrImg",
            requestType: UploadSrImgRequest,
            requestStream: false,
            responseType: UploadSrImgResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            34,
                            18,
                            32,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            117,
                            112,
                            108,
                            111,
                            97,
                            100,
                            95,
                            115,
                            114,
                            95,
                            105,
                            109,
                            103,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_api_v1_\{subreddit\}_post_requirements */
        subredditPostRequirements: {
            name: "SubredditPostRequirements",
            requestType: BasicSubredditRequest,
            requestStream: false,
            responseType: SubredditPostRequirementsResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            39,
                            18,
                            37,
                            47,
                            97,
                            112,
                            105,
                            47,
                            118,
                            49,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            112,
                            111,
                            115,
                            116,
                            95,
                            114,
                            101,
                            113,
                            117,
                            105,
                            114,
                            101,
                            109,
                            101,
                            110,
                            116,
                            115,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_r_\{subreddit\}_about */
        subredditAbout: {
            name: "SubredditAbout",
            requestType: BasicSubredditRequest,
            requestStream: false,
            responseType: SubredditAboutResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            55,
                            18,
                            53,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            98,
                            111,
                            117,
                            116,
                            63,
                            113,
                            117,
                            97,
                            114,
                            97,
                            110,
                            116,
                            105,
                            110,
                            101,
                            95,
                            111,
                            112,
                            116,
                            105,
                            110,
                            61,
                            49,
                            38,
                            103,
                            97,
                            116,
                            101,
                            100,
                            95,
                            111,
                            112,
                            116,
                            105,
                            110,
                            61,
                            49,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                        new Uint8Array([2, 88, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_r_\{subreddit\}_about_edit */
        subredditAboutEdit: {
            name: "SubredditAboutEdit",
            requestType: SubredditAboutEditRequest,
            requestStream: false,
            responseType: SubredditAboutEditResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            65,
                            18,
                            63,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            98,
                            111,
                            117,
                            116,
                            47,
                            101,
                            100,
                            105,
                            116,
                            63,
                            99,
                            114,
                            101,
                            97,
                            116,
                            101,
                            100,
                            61,
                            123,
                            99,
                            114,
                            101,
                            97,
                            116,
                            101,
                            100,
                            125,
                            38,
                            108,
                            111,
                            99,
                            97,
                            116,
                            105,
                            111,
                            110,
                            61,
                            123,
                            108,
                            111,
                            99,
                            97,
                            116,
                            105,
                            111,
                            110,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_r_\{subreddit\}_about_rules */
        subredditAboutRules: {
            name: "SubredditAboutRules",
            requestType: BasicSubredditRequest,
            requestStream: false,
            responseType: SubredditAboutRulesResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            28,
                            18,
                            26,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            98,
                            111,
                            117,
                            116,
                            47,
                            114,
                            117,
                            108,
                            101,
                            115,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** Add a subreddit rule. */
        addSubredditRule: {
            name: "AddSubredditRule",
            requestType: AddSubredditRuleRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            25,
                            18,
                            23,
                            47,
                            97,
                            112,
                            105,
                            47,
                            97,
                            100,
                            100,
                            95,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            95,
                            114,
                            117,
                            108,
                            101,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([3, 58, 1, 114]),
                    ],
                },
            },
        },
        /** Update an existing subreddit rule. */
        updateSubredditRule: {
            name: "UpdateSubredditRule",
            requestType: UpdateSubredditRuleRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            28,
                            18,
                            26,
                            47,
                            97,
                            112,
                            105,
                            47,
                            117,
                            112,
                            100,
                            97,
                            116,
                            101,
                            95,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            95,
                            114,
                            117,
                            108,
                            101,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([3, 58, 1, 114]),
                    ],
                },
            },
        },
        /** Remove a subreddit rule. */
        removeSubredditRule: {
            name: "RemoveSubredditRule",
            requestType: RemoveSubredditRuleRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            28,
                            18,
                            26,
                            47,
                            97,
                            112,
                            105,
                            47,
                            114,
                            101,
                            109,
                            111,
                            118,
                            101,
                            95,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            95,
                            114,
                            117,
                            108,
                            101,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([3, 58, 1, 114]),
                    ],
                },
            },
        },
        /** Reorder subreddit rules. */
        reorderSubredditRules: {
            name: "ReorderSubredditRules",
            requestType: ReorderSubredditRulesRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            30,
                            18,
                            28,
                            47,
                            97,
                            112,
                            105,
                            47,
                            114,
                            101,
                            111,
                            114,
                            100,
                            101,
                            114,
                            95,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            95,
                            114,
                            117,
                            108,
                            101,
                            115,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([3, 58, 1, 114]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_r_\{subreddit\}_about_traffic */
        subredditAboutTraffic: {
            name: "SubredditAboutTraffic",
            requestType: BasicSubredditRequest,
            requestStream: false,
            responseType: SubredditAboutTrafficResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            30,
                            18,
                            28,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            98,
                            111,
                            117,
                            116,
                            47,
                            116,
                            114,
                            97,
                            102,
                            102,
                            105,
                            99,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_sidebar */
        sidebar: {
            name: "Sidebar",
            requestType: BasicSubredditRequest,
            requestStream: false,
            responseType: StringValue,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            24,
                            18,
                            22,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            115,
                            105,
                            100,
                            101,
                            98,
                            97,
                            114,
                        ]),
                        new Uint8Array([2, 64, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_sticky */
        sticky: {
            name: "Sticky",
            requestType: StickyRequest,
            requestStream: false,
            responseType: StickyResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            33,
                            18,
                            31,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            115,
                            116,
                            105,
                            99,
                            107,
                            121,
                            63,
                            110,
                            117,
                            109,
                            61,
                            123,
                            110,
                            117,
                            109,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_subreddits_mine_\{where\} */
        subredditsMineWhere: {
            name: "SubredditsMineWhere",
            requestType: BasicWhereRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            96,
                            18,
                            94,
                            47,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            115,
                            47,
                            109,
                            105,
                            110,
                            101,
                            47,
                            123,
                            119,
                            104,
                            101,
                            114,
                            101,
                            125,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                        ]),
                    ],
                },
            },
        },
        /**
         * https://www.reddit.com/dev/api#GET_subreddits_search
         * Make Wrapped
         */
        subredditsSearch: {
            name: "SubredditsSearch",
            requestType: SubredditsSearchRequest,
            requestStream: false,
            responseType: SubredditsSearchResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            203,
                            1,
                            18,
                            200,
                            1,
                            47,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            115,
                            47,
                            115,
                            101,
                            97,
                            114,
                            99,
                            104,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            113,
                            61,
                            123,
                            113,
                            125,
                            38,
                            115,
                            101,
                            97,
                            114,
                            99,
                            104,
                            95,
                            113,
                            117,
                            101,
                            114,
                            121,
                            95,
                            105,
                            100,
                            61,
                            123,
                            115,
                            101,
                            97,
                            114,
                            99,
                            104,
                            95,
                            113,
                            117,
                            101,
                            114,
                            121,
                            95,
                            105,
                            100,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            95,
                            117,
                            115,
                            101,
                            114,
                            115,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            95,
                            117,
                            115,
                            101,
                            114,
                            115,
                            125,
                            38,
                            115,
                            111,
                            114,
                            116,
                            61,
                            123,
                            115,
                            111,
                            114,
                            116,
                            125,
                            38,
                            116,
                            121,
                            112,
                            101,
                            97,
                            104,
                            101,
                            97,
                            100,
                            95,
                            97,
                            99,
                            116,
                            105,
                            118,
                            101,
                            61,
                            123,
                            116,
                            121,
                            112,
                            101,
                            97,
                            104,
                            101,
                            97,
                            100,
                            95,
                            97,
                            99,
                            116,
                            105,
                            118,
                            101,
                            125,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_subreddits_\{where\} */
        subredditsWhere: {
            name: "SubredditsWhere",
            requestType: BasicWhereRequest,
            requestStream: false,
            responseType: SubredditsSearchResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            91,
                            18,
                            89,
                            47,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            115,
                            47,
                            123,
                            119,
                            104,
                            101,
                            114,
                            101,
                            125,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_users_search */
        usersSearch: {
            name: "UsersSearch",
            requestType: UsersSearchRequest,
            requestStream: false,
            responseType: UserSearchResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            174,
                            1,
                            18,
                            171,
                            1,
                            47,
                            117,
                            115,
                            101,
                            114,
                            115,
                            47,
                            115,
                            101,
                            97,
                            114,
                            99,
                            104,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            113,
                            61,
                            123,
                            113,
                            125,
                            38,
                            115,
                            101,
                            97,
                            114,
                            99,
                            104,
                            95,
                            113,
                            117,
                            101,
                            114,
                            121,
                            95,
                            105,
                            100,
                            61,
                            123,
                            115,
                            101,
                            97,
                            114,
                            99,
                            104,
                            95,
                            113,
                            117,
                            101,
                            114,
                            121,
                            95,
                            105,
                            100,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                            38,
                            115,
                            111,
                            114,
                            116,
                            61,
                            123,
                            115,
                            111,
                            114,
                            116,
                            125,
                            38,
                            116,
                            121,
                            112,
                            101,
                            97,
                            104,
                            101,
                            97,
                            100,
                            95,
                            97,
                            99,
                            116,
                            105,
                            118,
                            101,
                            61,
                            123,
                            116,
                            121,
                            112,
                            101,
                            97,
                            104,
                            101,
                            97,
                            100,
                            95,
                            97,
                            99,
                            116,
                            105,
                            118,
                            101,
                            125,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_users_\{where\} */
        usersWhere: {
            name: "UsersWhere",
            requestType: BasicWhereRequest,
            requestStream: false,
            responseType: SubredditsSearchResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            86,
                            18,
                            84,
                            47,
                            117,
                            115,
                            101,
                            114,
                            115,
                            47,
                            123,
                            119,
                            104,
                            101,
                            114,
                            101,
                            125,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                        ]),
                    ],
                },
            },
        },
        /**
         * Add a removal reason to a subreddit.
         *
         * POST /api/v1/{subreddit}/removal_reasons
         */
        subredditAddRemovalReason: {
            name: "SubredditAddRemovalReason",
            requestType: SubredditAddRemovalReasonRequest,
            requestStream: false,
            responseType: SubredditAddRemovalReasonResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            37,
                            18,
                            35,
                            47,
                            97,
                            112,
                            105,
                            47,
                            118,
                            49,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            114,
                            101,
                            109,
                            111,
                            118,
                            97,
                            108,
                            95,
                            114,
                            101,
                            97,
                            115,
                            111,
                            110,
                            115,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Get the list of subreddit's removal reasons.
         *
         * GET /api/v1/{subreddit}/removal_reasons
         */
        subredditGetRemovalReasons: {
            name: "SubredditGetRemovalReasons",
            requestType: SubredditGetRemovalReasonsRequest,
            requestStream: false,
            responseType: SubredditGetRemovalReasonsResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            37,
                            18,
                            35,
                            47,
                            97,
                            112,
                            105,
                            47,
                            118,
                            49,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            114,
                            101,
                            109,
                            111,
                            118,
                            97,
                            108,
                            95,
                            114,
                            101,
                            97,
                            115,
                            111,
                            110,
                            115,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Update an existing removal reason.
         *
         * PUT /api/v1/{subreddit}/removal_reasons/{reason_id}
         */
        subredditUpdateRemovalReason: {
            name: "SubredditUpdateRemovalReason",
            requestType: SubredditUpdateRemovalReasonRequest,
            requestStream: false,
            responseType: SubredditUpdateRemovalReasonResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 80, 85, 84]),
                        new Uint8Array([
                            49,
                            18,
                            47,
                            47,
                            97,
                            112,
                            105,
                            47,
                            118,
                            49,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            114,
                            101,
                            109,
                            111,
                            118,
                            97,
                            108,
                            95,
                            114,
                            101,
                            97,
                            115,
                            111,
                            110,
                            115,
                            47,
                            123,
                            114,
                            101,
                            97,
                            115,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                        ]),
                        new Uint8Array([2, 24, 4]),
                        new Uint8Array([2, 32, 1]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Delete an existing removal reason.
         *
         * DELETE /api/v1/{subreddit}/removal_reasons/{reason_id}
         */
        subredditDeleteRemovalReason: {
            name: "SubredditDeleteRemovalReason",
            requestType: SubredditDeleteRemovalReasonRequest,
            requestStream: false,
            responseType: SubredditDeleteRemovalReasonResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([8, 10, 6, 68, 69, 76, 69, 84, 69]),
                        new Uint8Array([
                            49,
                            18,
                            47,
                            47,
                            97,
                            112,
                            105,
                            47,
                            118,
                            49,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            114,
                            101,
                            109,
                            111,
                            118,
                            97,
                            108,
                            95,
                            114,
                            101,
                            97,
                            115,
                            111,
                            110,
                            115,
                            47,
                            123,
                            114,
                            101,
                            97,
                            115,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /** Get highlighted posts in a subreddit. */
        getHighlightedPosts: {
            name: "GetHighlightedPosts",
            requestType: GetHighlightedPostsRequest,
            requestStream: false,
            responseType: GetHighlightedPostsResponse,
            responseStream: false,
            options: {},
        },
        /** Reorder highlighted posts in a subreddit. */
        reorderHighlightedPosts: {
            name: "ReorderHighlightedPosts",
            requestType: ReorderHighlightedPostsRequest,
            requestStream: false,
            responseType: ReorderHighlightedPostsResponse,
            responseStream: false,
            options: {},
        },
    },
};
